<template>
  <!--
          作者：luoyiming
          时间：2019-10-25
          描述：商户-商户管理
      -->
  <div class="user">

    <!--添加商户-->
    <div class="common-level-rail fl clearfix">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/supplier/supplier/add'">
        添加商户
      </el-button>
    </div>
    <div class="common-seach-wrap fr">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">
          <el-input v-model="formInline.search" placeholder="请输入商户名称"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="shopSupplierId" label="商户ID" width="70"></el-table-column>
          <el-table-column label="logo" width="80">
            <template slot-scope="scope">
              <!--              <el-image v-if="scope.row.logoId" :src="scope.row.logoFilePath"-->
              <!--                        width="50" height="50" :preview-src-list="getLogoList(scope.$index)"/>-->
              <div style="width: 50px;height: 50px;border-radius: 50%;overflow: hidden">
                <img v-img-url="scope.row.logoFilePath" style="width: 100%;min-height: 100%">
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="商户名称" min-width="100px"></el-table-column>
          <el-table-column prop="storeType" label="店铺类型" width="90">
            <template slot-scope="scope">
              {{ getShowStoreType(scope.row.storeType) }}
            </template>
          </el-table-column>
          <el-table-column prop="userName" label="登录账号" min-width="100px"></el-table-column>

          <el-table-column prop="linkName" label="联系人" width="90"></el-table-column>
          <el-table-column prop="linkPhone" label="联系电话" width="120"></el-table-column>
          <el-table-column prop="address" label="联系地址" min-width="180px"></el-table-column>
          <el-table-column prop="orderTotal" label="订单数量" align="center" width="100px" v-if="storeType === 10">
          </el-table-column>
          <el-table-column prop="saleMoney" label="销售额" align="center" width="100px" v-if="storeType === 10">>
            <template slot-scope="scope">
              <span class="color-red">
              {{ scope.row.saleMoney }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="添加时间" width="160"></el-table-column>
          <el-table-column label="二维码" width="80" v-if="storeType === 10">
            <template slot-scope="scope">
              <el-image v-if="scope.row.wxQrCode" :src="scope.row.wxQrCode" @click="handleSupplieQrCode(scope.row)"
                        style="cursor: pointer" width="50" height="50"/>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" :width="storeType===10?290:220">
            <template slot-scope="scope">
              <el-button @click="productClick(scope.row)" type="text" size="small"
                         v-auth="'/supplier/supplier/product/index'">商品
              </el-button>
              <el-button @click="showWxUrlLink(scope.row)" type="text" size="small"
                         v-if="storeType===10"
                         v-auth="'/supplier/supplier/edit'">分享码
              </el-button>
              <el-button @click="decorationClick(scope.row)" type="text" size="small"
                         v-auth="'/supplier/supplier/edit'">装修
              </el-button>
              <el-button @click="recycle(scope.row,0)" type="text" size="small" v-auth="'/supplier/supplier/edit'"
                         v-if="scope.row.isRecycle==1" style="color:gray;">开启
              </el-button>
              <el-button @click="recycle(scope.row,1)" type="text" size="small" v-auth="'/supplier/supplier/edit'"
                         v-else>禁用
              </el-button>
              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/supplier/supplier/edit'">
                编辑
              </el-button>
              <el-button @click="deleteClick(scope.row.shopSupplierId)" type="text" size="small"
                         v-auth="'/supplier/supplier/delete'">删除
              </el-button>

            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                       :current-page="curPage"
                       :page-size="pageSize" layout="total, prev, pager, next, jumper"
                       :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :title="supplierName + '二维码'" :close-on-click-modal="false"
      :visible.sync="showQrCode"
      center
      width="550px"
    >
      <div
        style="border: 1px solid #D1D2D3;margin-top: -20px;display: flex;justify-content: center;align-items: center">
        <div
          style="width:90%;flex-shrink: 0;display: flex;flex-direction: column;justify-content: center;align-items: center">
          <img :src="supplieQrcode" alt="" class="" ref="poster"
               style="width: 360px; height: 540px;margin-top: 20px"
          >
          <div
            @click="onQrcodeDownload"
            style="margin-top:20px;margin-bottom: 30px;width: 143px;height:33px ;border-radius: 3px;border:1px solid #67B3FF;background-color:#E6F1FC;cursor: pointer;display: flex;justify-content: center;align-items: center"
          >
            <img alt="" src="../../../assets/common/ic_xiazai@2x.png"
                 style="width:15px;height: 14px;"
            >
            <div style="color:#1989FA;font-size: 14px;margin-left: 5px">
              立即下载
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="supplierName + '分享码'" :close-on-click-modal="false"
      :visible.sync="showWxUrl"
      center
      width="550px"
    >
      <el-input v-model="wxUrlLink" readonly>
        <template slot="append"><span v-clipboard:copy="wxUrlLink" v-clipboard:success="copy"
                                      v-clipboard:error="onerror" style="cursor: pointer">复制</span></template>
      </el-input>
      <div class="margin-top-30 flex a-center j-center">
        <el-button @click="onWxUrlGet()">重新获取</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SupplierApi from '@/api/supplier.js'
import html2canvas from 'html2canvas'
import FileSaver from 'file-saver'

export default {
  name: 'SupplierComponent',
  components: {},
  props: {
    storeType: Number
  },
  data () {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*提货站点列表数据*/
      storeList: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        search: ''
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      logoImgs: [],
      businessImgs: [],

      supplierName: '',
      supplieQrcode: '',
      showQrCode: false,                        //显示企业码
      selectRow: null,
      showWxUrl: false,
      wxUrlLink: ''
    }
  },
  created () {
    /*获取列表*/
    this.getTableList()
  },
  methods: {

    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.curPage = val
      self.loading = true
      self.getTableList()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.curPage = 1
      this.pageSize = val
      this.getTableList()
    },

    /*获取列表*/
    getTableList () {
      let self = this
      let Params = this.formInline
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      Params.storeType = this.storeType
      SupplierApi.supplierList(Params, true)
        .then(res => {
          self.loading = false
          self.tableData = res.data.records
          self.totalDataNumber = res.data.total
          self.tableData.forEach(function (item) {
            if (item.business) {
              self.businessImgs.push(item.businessFilePath)
            }
            if (item.logo) {
              self.logoImgs.push(item.logoFilePath)
            }
          })
        })
        .catch(error => {
          self.loading = false
        })
    },
    getLogoList (index) {
      return this.logoImgs.slice(index).concat(this.logoImgs.slice(0, index))
    },
    getBusinessList (index) {
      return this.businessImgs.slice(index).concat(this.businessImgs.slice(0, index))
    },
    /*搜索查询*/
    onSubmit () {
      this.curPage = 1
      this.getTableList()
    },


    /*打开添加*/
    addClick () {
      this.$router.push('/supplier/supplier/add')
    },
    productClick (row) {
      let shopSupplierId = row.shopSupplierId
      let storeType = row.storeType
      this.$router.push({
        path: '/supplier/supplier/product/index',
        query: {
          shopSupplierId,
          storeType
        }
      })
    },
    /*打开编辑*/
    editClick (row) {
      let self = this
      let params = row.shopSupplierId
      this.$router.push({
        path: '/supplier/supplier/edit',
        query: {
          shopSupplierId: params
        }
      })
    },
    /* 强制下架上架*/
    recycle (row, state) {
      let self = this
      let war = ''
      if (state == 1) {
        war = '禁止'
      } else if (state == 0) {
        war = '开启'
      }
      self
        .$confirm('确认要' + war + '吗?', '提示', {
          type: 'warning'
        })
        .then(() => {
          SupplierApi.supplierRecycle({
            shopSupplierId: row.shopSupplierId,
            isRecycle: state
          }).then(data => {
            self.$message({
              message: war + '成功',
              type: 'success'
            })
            self.getTableList()
          })
        })
    },
    /*删除*/
    deleteClick (row) {
      let self = this
      self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.loading = true
        SupplierApi.deleteSupplier({
          shopSupplierId: row
        }, true)
          .then(data => {
            self.loading = false
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，商户删除成功',
                type: 'success'
              })
              self.getTableList()
            }
          })
          .catch(error => {
            self.loading = false
          })

      }).catch(() => {
        self.loading = false
      })
    },
    decorationClick (row) {
      this.$router.push({
        path: '/page/page/editpage',
        query:
          {
            shopSupplierId: row.shopSupplierId,
            pageId: row.homePageId,
          }
      })

    },
    handleSupplieQrCode (row) {
      this.supplieQrcode = row.wxStoreCode
      this.supplierName = row.name || ''
      this.showQrCode = true
    },
    showWxUrlLink (row) {
      this.selectRow = row
      this.supplierName = row.name || ''
      this.wxUrlLink = row.wxUrlLink || ''
      this.showWxUrl = true
    },
    onWxUrlGet () {
      let shopSupplierId = this.selectRow.shopSupplierId || 0
      if (shopSupplierId) {
        SupplierApi.getRefreshWxUrl({
          shopSupplierId
        }, true).then(res => {
          this.wxUrlLink = res.data
          this.selectRow.wxUrlLink = this.wxUrlLink
          this.$message.info('重新获取成功')
        })
      }
    },
    copy () {
      this.$message.info('复制成功')
    },
    onerror () {
      this.$message.info('复制失败')
    },
    async onQrcodeDownload () {
      if (this.supplieQrcode) {
        // let downloadUrl = this.supplieQrcode
        // let downloadUrl = "http://image.test.laodao.so/image/wx/qrcode/ent/gradle_ent_08a71b9f-a5e2-3da9-923b-4de10516f996.png"
        // if (!this.supplieQrcode.startsWith('https')) {
        //   downloadUrl = this.supplieQrcode.replace('https', 'http')
        // }
        // handleSimpleDownload({name: this.supplierName + '.png', url: downloadUrl})

        const opts = {
          useCORS: true,
          scale: 2
        }
        const canvas = await html2canvas(this.$refs.poster, opts)
        canvas.toBlob(blob => {
          FileSaver.saveAs(blob, this.supplierName + '.png')
        })
      }
    },
    getShowStoreType (storeType) {
      let text = ''
      switch (parseInt(storeType)) {
        case 10:
          text = '分销商店铺'
          break
        case 20:
          text = '供应商店铺'
          break
      }
      return text
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/SupplierComponent.vue